var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.292969,
    y: 0.886719,
    width: 23.4082,
    height: 23.4082,
    rx: 11.7041,
    fill: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9954 17.9927C10.6149 17.9927 9.41219 17.5351 8.38708 16.6201C7.36198 15.705 6.7742 14.5621 6.62376 13.1912H7.85413C7.99417 14.2316 8.45691 15.0918 9.24234 15.772C10.0278 16.4522 10.9454 16.7923 11.9954 16.7923C13.1657 16.7923 14.1586 16.3848 14.974 15.5698C15.7895 14.7547 16.197 13.7618 16.1966 12.5911C16.1962 11.4203 15.7887 10.4276 14.974 9.61298C14.1594 8.79833 13.1665 8.39061 11.9954 8.38981C11.3052 8.38981 10.66 8.54986 10.0598 8.86995C9.4596 9.19005 8.95445 9.63018 8.54433 10.1903H10.1948V11.3907H6.59375V7.78963H7.79411V9.20005C8.30426 8.55986 8.92705 8.06471 9.66247 7.71461C10.3979 7.36451 11.1755 7.18945 11.9954 7.18945C12.7456 7.18945 13.4484 7.3321 14.1038 7.61738C14.7592 7.90267 15.3294 8.28758 15.8143 8.77213C16.2992 9.25667 16.6844 9.82684 16.9696 10.4826C17.2549 11.1384 17.3974 11.8412 17.397 12.5911C17.3966 13.3409 17.2541 14.0437 16.9696 14.6995C16.6852 15.3553 16.3 15.9255 15.8143 16.41C15.3286 16.8945 14.7584 17.2797 14.1038 17.5653C13.4492 17.851 12.7464 17.9935 11.9954 17.9927ZM13.6759 15.1118L11.3952 12.8311V9.59017H12.5955V12.351L14.5161 14.2716L13.6759 15.1118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.91805c6ea39461b30924ab4c7c0b91a1.svg";
export { ForwardRef as ReactComponent };